module.exports = "- Announce progress after a specified threshold.\n"